import iconAdd from '@/images/svg_base/button/add.svg';
import iconArrowDown from '@/images/svg_base/button/arrow-down.svg';
import iconArrowRight from '@/images/svg_base/button/arrow-right.svg';
import iconArrow from '@/images/svg_base/button/arrow.svg';
import iconCalendar from '@/images/svg_base/button/calendar.svg';
import iconClose from '@/images/svg_base/button/close.svg';
import iconCondition from '@/images/svg_base/button/condition.svg';
import iconCopy from '@/images/svg_base/button/copy.svg';
import iconDelete from '@/images/svg_base/button/delete.svg';
import iconDeleteAll from '@/images/svg_base/button/delete_all.svg';
import iconDetail from '@/images/svg_base/button/detail.svg';
import iconDownload from '@/images/svg_base/button/download.svg';
import iconDownloadList from '@/images/svg_base/button/download_list.svg';
import iconEdit from '@/images/svg_base/button/edit.svg';
import iconEditHover from '@/images/svg_base/button/edit_hover.svg';
import iconError from '@/images/svg_base/button/error.svg';
import iconExport from '@/images/svg_base/button/export.svg';
import iconEye from '@/images/svg_base/button/eye.svg';
import iconGreenStatus from '@/images/svg_base/button/greenStatus.svg';
import iconHelp from '@/images/svg_base/button/help.svg';
import iconHistory from '@/images/svg_base/button/history.svg';
import iconLink from '@/images/svg_base/button/link.svg';
import iconList from '@/images/svg_base/button/list.svg';
import iconNoeye from '@/images/svg_base/button/noeye.svg';
import iconOpen from '@/images/svg_base/button/open.svg';
import iconPic from '@/images/svg_base/button/pic.svg';
import iconPreview from '@/images/svg_base/button/preview.svg';
import iconRefresh from '@/images/svg_base/button/refresh.svg';
import iconRight from '@/images/svg_base/button/right.svg';
import iconSave from '@/images/svg_base/button/save.svg';
import iconSearch from '@/images/svg_base/button/search.svg';
import iconSkip from '@/images/svg_base/button/skip.svg';
import iconSuccess from '@/images/svg_base/button/success.svg';
import iconUrl from '@/images/svg_base/button/url.svg';
import iconWarning from '@/images/svg_base/button/warning.svg';
import iconWatch from '@/images/svg_base/button/watch.svg';
import iconWechatGreen from '@/images/svg_base/button/wechat-green.svg';
import iconWechatGrey from '@/images/svg_base/button/wechat-grey.svg';
import iconWrong from '@/images/svg_base/button/wrong.svg';
import iconAllService from '@/images/svg_base/feature/all_service.svg';
import iconApiData from '@/images/svg_base/feature/api_data.svg';
import iconApiList from '@/images/svg_base/feature/api_list.svg';
import iconAssetConfig from '@/images/svg_base/feature/asset_config.svg';
import iconAssetManage from '@/images/svg_base/feature/asset_manage.svg';
import iconBaseInfo from '@/images/svg_base/feature/base_info.svg';
import iconBlockFilter from '@/images/svg_base/feature/block_filter.svg';
import iconCpu from '@/images/svg_base/feature/cpu.svg';
import iconCustom from '@/images/svg_base/feature/custom.svg';
import iconDist from '@/images/svg_base/feature/dist.svg';
import iconDomains from '@/images/svg_base/feature/domains.svg';
import iconDown from '@/images/svg_base/feature/down.svg';
import iconElasticsearch from '@/images/svg_base/feature/Elasticsearch.svg';
import iconExtranetAssets from '@/images/svg_base/feature/extranet_assets.svg';
import iconFileDownload from '@/images/svg_base/feature/file_download.svg';
import iconFilter from '@/images/svg_base/feature/filter.svg';
import iconFireWall from '@/images/svg_base/feature/fire_wall.svg';
import iconFtp from '@/images/svg_base/feature/FTP.svg';
import iconGitlab from '@/images/svg_base/feature/gitlab.svg';
import iconHfishClient from '@/images/svg_base/feature/hfish_client.svg';
import iconHttp from '@/images/svg_base/feature/HTTP.svg';
import iconIntel from '@/images/svg_base/feature/intel.svg';
import iconIpList from '@/images/svg_base/feature/ip_list.svg';
import iconLinkBlock from '@/images/svg_base/feature/link_block.svg';
import iconLinux from '@/images/svg_base/feature/linux.svg';
import iconLoad from '@/images/svg_base/feature/load.svg';
import iconLog from '@/images/svg_base/feature/log.svg';
import iconLoginInterface from '@/images/svg_base/feature/login_interface.svg';
import iconMaintain from '@/images/svg_base/feature/maintain.svg';
import iconMysql from '@/images/svg_base/feature/Mysql.svg';
import iconNotice from '@/images/svg_base/feature/notice.svg';
import iconOa from '@/images/svg_base/feature/oa.svg';
import iconOtherHoney from '@/images/svg_base/feature/other_honey.svg';
import iconOutlook from '@/images/svg_base/feature/outlook.svg';
import iconRam from '@/images/svg_base/feature/ram.svg';
import iconRedis from '@/images/svg_base/feature/Redis.svg';
import iconReport from '@/images/svg_base/feature/report.svg';
import iconSafetyEquipment from '@/images/svg_base/feature/safety_equipment.svg';
import iconScreen from '@/images/svg_base/feature/screen.svg';
import iconSensitiveInfo from '@/images/svg_base/feature/sensitive_info.svg';
import iconSiem from '@/images/svg_base/feature/siem.svg';
import iconSsh from '@/images/svg_base/feature/Ssh.svg';
import iconStatus from '@/images/svg_base/feature/status.svg';
import iconTcp from '@/images/svg_base/feature/TCP.svg';
import iconTdpClient from '@/images/svg_base/feature/tdp_client.svg';
import iconTelnet from '@/images/svg_base/feature/telnet.svg';
import iconTftp from '@/images/svg_base/feature/TFTP.svg';
import iconUserManage from '@/images/svg_base/feature/user_manage.svg';
import iconVnc from '@/images/svg_base/feature/Vnc.svg';
import iconWindows from '@/images/svg_base/feature/windows.svg';
import iconWordpress from '@/images/svg_base/feature/wordpress.svg';
import iconAlert from '@/images/svg_base/function/alert.svg';
import iconAlertHost from '@/images/svg_base/function/alert_host.svg';
import iconAlertLog from '@/images/svg_base/function/alert_log.svg';
import iconAllData from '@/images/svg_base/function/all_data.svg';
import iconAsset from '@/images/svg_base/function/asset.svg';
import iconAttackSuccess from '@/images/svg_base/function/attack_success.svg';
import iconAuthService from '@/images/svg_base/function/auth_service.svg';
import iconBlocked from '@/images/svg_base/function/blocked.svg';
import iconBug from '@/images/svg_base/function/bug.svg';
import iconCloudDisconnect from '@/images/svg_base/function/cloud_disconnect.svg';
import iconCloudIntel from '@/images/svg_base/function/cloud_intel.svg';
import iconCode from '@/images/svg_base/function/code.svg';
import iconConfigFile from '@/images/svg_base/function/configFile.svg';
import iconControl from '@/images/svg_base/function/control.svg';
import iconDatabase from '@/images/svg_base/function/database.svg';
import iconDetect from '@/images/svg_base/function/detect.svg';
import iconDomain from '@/images/svg_base/function/domain.svg';
import iconExploit from '@/images/svg_base/function/exploit.svg';
import iconFallHost from '@/images/svg_base/function/fall_host.svg';
import iconFileTranslate from '@/images/svg_base/function/file_translate.svg';
import iconHosts from '@/images/svg_base/function/hosts.svg';
import iconHwBlock from '@/images/svg_base/function/hw_block.svg';
import iconInfo from '@/images/svg_base/function/info.svg';
import iconInterface from '@/images/svg_base/function/interface.svg';
import iconMail from '@/images/svg_base/function/mail.svg';
import iconMaliciousFile from '@/images/svg_base/function/malicious_file.svg';
import iconMining from '@/images/svg_base/function/mining.svg';
import iconNewService from '@/images/svg_base/function/new_service.svg';
import iconOfflineHoney from '@/images/svg_base/function/offline_honey.svg';
import iconOfflineNode from '@/images/svg_base/function/offline_node.svg';
import iconOnlineHoney from '@/images/svg_base/function/online_honey.svg';
import iconOnlineNode from '@/images/svg_base/function/online_node.svg';
import iconPublic from '@/images/svg_base/function/public.svg';
import iconRecon from '@/images/svg_base/function/recon.svg';
import iconSelf from '@/images/svg_base/function/self.svg';
import iconSelfSearch from '@/images/svg_base/function/self_search.svg';
import iconServer from '@/images/svg_base/function/server.svg';
import iconSteal from '@/images/svg_base/function/steal.svg';
import iconThreatEvent from '@/images/svg_base/function/threat_event.svg';
import iconThreatName from '@/images/svg_base/function/threat_name.svg';
import iconUnopen from '@/images/svg_base/function/unopen.svg';
import iconUpload from '@/images/svg_base/function/upload.svg';
import iconWarningYellow from '@/images/svg_base/function/warning_yellow.svg';
import iconWindowsFile from '@/images/svg_base/function/windowsFile.svg';
import iconAttack from '@/images/svg_base/attackchain/attack.svg';
import iconAttackIp from '@/images/svg_base/attackchain/attack_ip.svg';
import iconBaitCount from '@/images/svg_base/attackchain/bait_count.svg';
import iconDangerLogin from '@/images/svg_base/attackchain/danger_login.svg';
import iconLogin from '@/images/svg_base/attackchain/login.svg';
import iconLost from '@/images/svg_base/attackchain/lost.svg';
import iconMessageWatch from '@/images/svg_base/attackchain/message_watch.svg';
import iconScanner from '@/images/svg_base/attackchain/scanner.svg';
export const iconMap = {
  add: iconAdd,
  arrowDown: iconArrowDown,
  arrowRight: iconArrowRight,
  arrow: iconArrow,
  calendar: iconCalendar,
  close: iconClose,
  condition: iconCondition,
  copy: iconCopy,
  delete: iconDelete,
  deleteAll: iconDeleteAll,
  detail: iconDetail,
  download: iconDownload,
  downloadList: iconDownloadList,
  edit: iconEdit,
  editHover: iconEditHover,
  error: iconError,
  export: iconExport,
  eye: iconEye,
  greenStatus: iconGreenStatus,
  help: iconHelp,
  history: iconHistory,
  link: iconLink,
  list: iconList,
  noeye: iconNoeye,
  open: iconOpen,
  pic: iconPic,
  preview: iconPreview,
  refresh: iconRefresh,
  right: iconRight,
  save: iconSave,
  search: iconSearch,
  skip: iconSkip,
  success: iconSuccess,
  url: iconUrl,
  warning: iconWarning,
  watch: iconWatch,
  wechatGreen: iconWechatGreen,
  wechatGrey: iconWechatGrey,
  wrong: iconWrong,
  allService: iconAllService,
  apiData: iconApiData,
  apiList: iconApiList,
  assetConfig: iconAssetConfig,
  assetManage: iconAssetManage,
  baseInfo: iconBaseInfo,
  blockFilter: iconBlockFilter,
  cpu: iconCpu,
  custom: iconCustom,
  dist: iconDist,
  domains: iconDomains,
  down: iconDown,
  elasticsearch: iconElasticsearch,
  extranetAssets: iconExtranetAssets,
  fileDownload: iconFileDownload,
  filter: iconFilter,
  fireWall: iconFireWall,
  ftp: iconFtp,
  gitlab: iconGitlab,
  hfishClient: iconHfishClient,
  http: iconHttp,
  intel: iconIntel,
  ipList: iconIpList,
  linkBlock: iconLinkBlock,
  linux: iconLinux,
  load: iconLoad,
  log: iconLog,
  loginInterface: iconLoginInterface,
  maintain: iconMaintain,
  mysql: iconMysql,
  notice: iconNotice,
  oa: iconOa,
  otherHoney: iconOtherHoney,
  outlook: iconOutlook,
  ram: iconRam,
  redis: iconRedis,
  report: iconReport,
  safetyEquipment: iconSafetyEquipment,
  screen: iconScreen,
  sensitiveInfo: iconSensitiveInfo,
  siem: iconSiem,
  ssh: iconSsh,
  status: iconStatus,
  tcp: iconTcp,
  tdpClient: iconTdpClient,
  telnet: iconTelnet,
  tftp: iconTftp,
  userManage: iconUserManage,
  vnc: iconVnc,
  windows: iconWindows,
  wordpress: iconWordpress,
  alert: iconAlert,
  alertHost: iconAlertHost,
  alertLog: iconAlertLog,
  allData: iconAllData,
  asset: iconAsset,
  attackSuccess: iconAttackSuccess,
  authService: iconAuthService,
  blocked: iconBlocked,
  bug: iconBug,
  cloudDisconnect: iconCloudDisconnect,
  cloudIntel: iconCloudIntel,
  code: iconCode,
  configFile: iconConfigFile,
  control: iconControl,
  database: iconDatabase,
  detect: iconDetect,
  domain: iconDomain,
  exploit: iconExploit,
  fallHost: iconFallHost,
  fileTranslate: iconFileTranslate,
  hosts: iconHosts,
  hwBlock: iconHwBlock,
  info: iconInfo,
  interface: iconInterface,
  mail: iconMail,
  maliciousFile: iconMaliciousFile,
  mining: iconMining,
  newService: iconNewService,
  offlineHoney: iconOfflineHoney,
  offlineNode: iconOfflineNode,
  onlineHoney: iconOnlineHoney,
  onlineNode: iconOnlineNode,
  public: iconPublic,
  recon: iconRecon,
  self: iconSelf,
  selfSearch: iconSelfSearch,
  server: iconServer,
  steal: iconSteal,
  threatEvent: iconThreatEvent,
  threatName: iconThreatName,
  unopen: iconUnopen,
  upload: iconUpload,
  warningYellow: iconWarningYellow,
  windowsFile: iconWindowsFile,
  attack: iconAttack,
  attackIp: iconAttackIp,
  baitCount: iconBaitCount,
  dangerLogin: iconDangerLogin,
  login: iconLogin,
  lost: iconLost,
  messageWatch: iconMessageWatch,
  scanner: iconScanner
};
